/* eslint-disable sonarjs/no-duplicate-string */
import * as React from 'react';

import { ColumnType } from 'rc-table';

export interface RowData {
	name: React.ReactNode;
	value?: string;
	section?: boolean;
}

export interface TableData {
	columns: Array<ColumnType<RowData>>;
	data: Array<RowData>;
}

const columns: Array<ColumnType<RowData>> = [
	{
		title: 'Benefit',
		dataIndex: 'name',
		key: 'name',
		width: '60%',
		align: 'start',
		render: (text: string, record: RowData) => {
			if (record.section) return text;
			if (!record.value) return <div className="table__section">{text}</div>;

			return text;
		},
	},
	{
		title: 'Maximum Benefit Amount',
		dataIndex: 'value',
		key: 'value',
		align: 'start',
		render: (value: string | undefined, record: RowData) => {
			if (record.section) return null;
			if (!value) return <div className="table__section" />;

			return value;
		},
	},
];

export const deluxe: TableData = {
	columns,
	data: [
		{
			name: 'Trip Cancellation**',
			value: 'up to 100% of Trip Cost*',
		},
		{
			name: 'Trip Interruption**',
			value: 'up to 150% of Trip Cost*',
		},
		{
			name: 'Trip Delay - 6 hours',
			value: 'up to $1,500 ($150/day)',
		},
		{
			name: 'Missed Connection',
			value: 'up to $750',
		},
		{
			name: 'Medical Evacuation and Repatriation of Remains',
			value: 'up to $500,000',
		},
		{
			name: 'Political or Security Evacuation and Natural Disaster Evacuation',
			value: 'up to $50,000',
		},
		{
			name: 'Baggage and Personal Effects',
			value: 'up to $1,500 ($250/article)',
		},
		{
			name: 'Baggage Delay - 6 hours',
			value: 'up to $500',
		},
		{
			name: 'Accident & Sickness Medical Expense',
			value: 'up to $250,000',
		},
		{
			name: <span style={{ paddingLeft: '4ch' }}>Dental Expense sublimit</span>,
			value: 'up to $750',
		},
		{
			name: '24-Hour Accident Death & Dismemberment Other Than Air Flight',
			value: 'up to $10,000',
		},
		{
			name: 'Non-Insurance Travel Assistance Services',
			value: 'Included',
		},
		{
			name: 'OPTIONAL BENEFIT BUNDLES & UPGRADES',
			section: true,
		},
		{
			name: <span>CANCEL AND INTERRUPT FOR ANY REASON BUNDLE<sup>1</sup></span>,
		},
		{
			name: 'Cancel For Any Reason**',
			value: 'up to 75% of non-refundable insured Trip Cost*',
		},
		{
			name: 'Interruption For Any Reason**',
			value: 'up to 75% of non-refundable insured Trip Cost*',
		},
		{
			name: 'RENTAL CAR DAMAGE AND THEFT COVERAGE',
		},
		{
			name: 'Rental Car Damage And Theft Coverage',
			value: 'up to $30,000',
		},
		{
			name: 'PET BUNDLE',
		},
		{
			name: 'Trip Cancellation**',
			value: 'up to 100% of non-refundable insured Trip Cost*',
		},
		{
			name: 'Trip Interruption**',
			value: 'up to 150% of non-refundable insured Trip Cost*',
		},
		{
			name: 'Pet Kennel',
			value: 'up to $50 per day up to a maximum of $500',
		},
		{
			name: 'Pet Travel Medical Expense',
			value: 'up to $1,000',
		},
		{
			name: 'Pet Return',
			value: 'up to $1,000',
		},
		{
			name: 'Hotel & Amusement & Theme Park Bundle',
		},
		{
			name: 'Change Fee',
			value: 'up to $250',
		},
		{
			name: 'Travel Inconvenience',
			value: 'up to a maximum of $150 ($50/inconvenience)',
		},
		{
			name: 'CRUISE BUNDLE',
		},
		{
			name: 'Trip Cancellation**',
			value: 'up to 100% of the non-refundable insured Trip Cost*',
		},
		{
			name: 'Trip Interruption**',
			value: 'up to 150% of the non-refundable insured Trip Cost*',
		},
		{
			name: 'Additional Trip Interruption',
			value: 'up to $500',
		},
		{
			name: 'Itinerary Change',
			value: 'up to $500',
		},
		{
			name: 'Travel Inconvenience',
			value: 'up to a maximum of $1,000 ($500/inconvenience)',
		},
		{
			name: 'Baggage & Personal Effects',
			value: 'up to $1,000',
		},
		{
			name: 'Baggage Delay',
			value: 'up to $2,000',
		},
		{
			name: 'Flight BuNDLE',
		},
		{
			name: 'Trip Cancellation** ',
			value: 'up to 100% of the non-refundable insured Trip Cost*',
		},
		{
			name: 'Trip Interruption**',
			value: 'up to 150% of the non-refundable insured Trip Cost*',
		},
		{
			name: 'Change Fee',
			value: 'up to $250',
		},
		{
			name: 'Frequent Traveler Reward',
			value: 'up to $250',
		},
		{
			name: 'Travel Inconvenience',
			value: 'up to $750 ($250/inconvenience)',
		},
		{
			name: 'Air Flight Only Accidental Death & Dismemberment',
			value: 'up to the limit purchased',
		},
		{
			name: 'trip delay upgrade',
		},
		{
			name: 'Trip Delay',
			value: 'up to $500',
		},
	],
};

export const platinum: TableData = {
	columns,
	data: [
		{
			name: 'Trip Cancellation**',
			value: 'up to 100% of Trip Cost*',
		},
		{
			name: 'Trip Interruption***',
			value: 'up to 150% of Trip Cost*',
		},
		{
			name: 'Trip Delay - 3 hours',
			value: 'up to $2,000 ($200/day)',
		},
		{
			name: 'Missed Connection',
			value: 'up to $1,000',
		},
		{
			name: 'Medical Evacuation and Repatriation of Remains',
			value: 'up to $1,000,000',
		},
		{
			name: 'Political or Security Evacuation and Natural Disaster Evacuation',
			value: 'up to $150,000',
		},
		{
			name: 'Baggage and Personal Effects',
			value: 'up to $2,500 ($250/article)',
		},
		{
			name: 'Baggage Delay - 3 hours',
			value: 'up to $750',
		},
		{
			name: 'Accident & Sickness Medical Expense',
			value: 'up to $500,000',
		},
		{
			name: <span style={{ paddingLeft: '4ch' }}>Dental Expense sublimit</span>,
			value: 'up to $750',
		},
		{
			name: '24-Hour Accident Death & Dismemberment Other Than Air Flight',
			value: 'up to $10,000',
		},
		{
			name: 'Non-Insurance Travel Assistance Services',
			value: 'Included',
		},
		{
			name: 'OPTIONAL BENEFIT BUNDLES & UPGRADES',
			section: true,
		},
		{
			name: <span>CANCEL AND INTERRUPT FOR ANY REASON BUNDLE<sup>1</sup></span>,
		},
		{
			name: 'Cancel For Any Reason**',
			value: 'up to 75% of non-refundable insured Trip Cost*',
		},
		{
			name: 'Interruption For Any Reason**',
			value: 'up to 75% of non-refundable insured Trip Cost*',
		},
		{
			name: 'RENTAL CAR DAMAGE AND THEFT COVERAGE',
		},
		{
			name: 'Rental Car Damage And Theft Coverage',
			value: 'up to $50,000',
		},
		{
			name: 'PET BUNDLE',
		},
		{
			name: 'Trip Cancellation**',
			value: 'up to 100% of non-refundable insured Trip Cost*',
		},
		{
			name: 'Trip Interruption***',
			value: 'up to 150% of non-refundable insured Trip Cost*',
		},
		{
			name: 'Pet Kennel',
			value: 'up to $50 per day up to a maximum of $500',
		},
		{
			name: 'Pet Travel Medical Expense',
			value: 'up to $1,000',
		},
		{
			name: 'Pet Return',
			value: 'up to $1,000',
		},
		{
			name: 'Hotel & Amusement & Theme Park Bundle',
		},
		{
			name: 'Change Fee',
			value: 'up to $250',
		},
		{
			name: 'Travel Inconvenience',
			value: 'up to a maximum of $150 ($50/inconvenience)',
		},
		{
			name: 'CRUISE BUNDLE',
		},
		{
			name: 'Trip Cancellation**',
			value: 'up to 100% of the non-refundable insured Trip Cost*',
		},
		{
			name: 'Trip Interruption***',
			value: 'up to 150% of the non-refundable insured Trip Cost*',
		},
		{
			name: 'Additional Trip Interruption',
			value: 'up to $500',
		},
		{
			name: 'Itinerary Change',
			value: 'up to $500',
		},
		{
			name: 'Travel Inconvenience',
			value: 'up to a maximum of $1,000 ($500/inconvenience)',
		},
		{
			name: 'Baggage Delay',
			value: 'up to $1,750',
		},
		{
			name: 'Flight BuNDLE',
		},
		{
			name: 'Trip Cancellation** ',
			value: 'up to 100% of the non-refundable insured Trip Cost*',
		},
		{
			name: 'Trip Interruption***',
			value: 'up to 150% of the non-refundable insured Trip Cost*',
		},
		{
			name: 'Change Fee',
			value: 'up to $250',
		},
		{
			name: 'Frequent Traveler Reward',
			value: 'up to $250',
		},
		{
			name: 'Travel Inconvenience',
			value: 'up to $750 ($250/inconvenience)',
		},
		{
			name: 'Air Flight Only Accidental Death & Dismemberment',
			value: 'up to the limit purchased',
		},
		{
			name: 'BAGGAGE BUNDLE',
		},
		{
			name: 'Baggage and Personal Effects',
			value: 'up to $2,500 ($250/article)',
		},
		{
			name: 'Sports Equipment, Golf Equipment, Business Equipment',
			value: 'Included',
		},
		{
			name: 'Extreme sports medical upgrade',
		},
		{
			name: 'Accident & Sickness Medical Expense Adventure or Extreme Activities',
			value: 'Included',
		},
	],
};
